<template>
  <v-app-bar
      height="64"
      flat
      color="white"
  >
    <h3>List Application</h3>
    <v-spacer/>
    <div style="width: 50%" class="hidden-md-and-down">
      <v-text-field
          outlined
          prepend-inner-icon="mdi-magnify"
          hide-details
          dense
          class="rounded-lg"
          placeholder="Search by ID or Name"
          flat
          solo
          v-model="search"
      ></v-text-field>
    </div>
    <v-spacer/>
    <v-btn
        depressed
        color="primary"
        class="text-none d-none"
        @click="showAppCreator=true"
    >
      Create Application
    </v-btn>
  </v-app-bar>
</template>

<script>
import {sync} from "vuex-pathify";

export default {
  name: "ApplicationListHeader",
  computed: {
    showAppCreator: sync('dialogs/showAppCreator'),
    search: sync('application/search')
  }
}
</script>

<style scoped>

</style>
